import { set } from 'lodash';
import React, { useState, useEffect } from 'react';

export default function BeefBracketVoteCard({
  view,
  scoreObject,
  setScoreObject,
  isLoading,
  setView,
  currentVote,
  setCurrentVote,
  handleTransitionToVoteForm
}) {
  return (
    <div className={`beef-bracket-vote-tally-score ${view}`}>
      <div className="beef-bracket-vote-tally-score-card">
        <div
          className="beef-bracket-vote-tally-score-image"
          style={{ backgroundImage: `url(${scoreObject.image})` }}
        >
          <img src={scoreObject.image} alt={scoreObject.title} />
        </div>
        <div className="beef-bracket-vote-tally-score-title">
          <h4>{scoreObject.title}</h4>
        </div>
        <div className="beef-bracket-vote-button beef-bracket-vote-tally-vs-button">
          <button
            onClick={() => {
              handleTransitionToVoteForm();
              setCurrentVote(scoreObject);
            }}
            className="btn btn-block wlTrackClick"
            data-wl-label="Beef Bracket Vote Button"
            data-wl-event="beef-bracket-vote-button-clicked"
          >
            Vote Now
          </button>
        </div>
      </div>
    </div>
  );
}
